import {useLocation, useNavigate, useRouteError} from "react-router-dom";
import { Alert, Container, Grid } from "@mui/material";
import Header from "./core/Header";
import {useEffect} from "react";
import {isPathHandlingNeeded, pathHandler} from "../utils/handlers";


const ErrorBoundary = () => {
    const error = useRouteError();
    const location = useLocation();
    const navigate = useNavigate();

    // const handlePathCondition  = () => {
    //     if(isPathHandlingNeeded(location)){
    //         navigate(pathHandler(location))
    //     }
    // }
    useEffect(() => {
      // handlePathCondition()
      navigate(pathHandler(location))
    }, [error]);

  return (
    <>
      <Header />
      <Container style={{ padding: 16, width: "40rem", marginTop: "9rem" }}>
        <Alert severity="error">
          <Grid>
            <h1>Oops ! </h1>
            <h3>Error has found in this page. </h3>
            <h3>Message : {error?.message}</h3>
            <h4>kindly contact your Admin</h4>
            {/* <a href={'/'}>Click here to go back</a> */}
          </Grid>
        </Alert>
      </Container>
    </>
  );
};

export default ErrorBoundary;
